// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueMatomo from 'vue-matomo'
import router from './router'
import store from '@/store'
import Vant, { Lazyload } from 'vant'
import 'vant/lib/index.css'
import '@/assets/css/common.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import request from '@/utils/request'
import snackbar from '@/components/snackbar'
require('@/utils/intersectionObserver')

Vue.prototype.$snackbar = snackbar
Vue.use(VueAwesomeSwiper)
Vue.use(Lazyload, {
  lazyComponent: true,
  observer: true
})
Vue.config.productionTip = false
Vue.prototype.request = request
Vue.use(Vant)

Vue.use(VueMatomo, {
  host: 'https://103.135.32.98:8080',
  siteId: 17,
  router,
  enableLinkTracking: true
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js